import { createSelector } from 'reselect';

import { SCREENS } from '../../data/planTorresConstants';

// TODO refactor those so-called selectors below into real selectors using reselect library

// creates and returns level tower based on level data (whether it's standard level or onboarding)
// difference from getLevelTower() below - it creates whole tower, relevant for particular level at the end of round
export const getLevelTower = level => level.standardItems.map(item => item.targetSyllables)
  .map(targetSyllables => targetSyllables.join(''))
  .reverse().concat(level.standardItems[0].referenceSyllables.join(''));

// creates and returns round tower based on round data (whether it's standard level or onboarding)
// difference from getLevelTower() above - it creates tower relevant for particular step
export const getRoundTower = round => (round.currentStepIndex === null ?
  // initially tower should have reference word
  [round.standardItems[0].referenceSyllables.join('')] :
  // on every next step target words get added into it one by one
  [round.standardItems[round.currentStepIndex].targetSyllables.join(''), ...round.tower]);

// creates and returns array with city level towers
export const getCity = ({ curriculum, gameDetails, feedback, onboardingRound, gameMode }) => {
  // if topper isn't selected yet, no need to generate city towers
  if (feedback.selectedTopperId === null) {
    return null;
  }

  // TODO definitely would be better to have onboarding flag in GameMode, e.g. onboradingMode: true
  const cityLevels = gameMode.onboardingMode ?
    // for ONBOARDING we pick only onboarding level
    [{ id: 0, standardItems: onboardingRound.standardItems }] :
    // for STANDARD we pick for city every level was mastered before or if it's current level
    curriculum.levels.filter(
      level => gameDetails.gameDetails.toppers[level.id] !== undefined || level.id === curriculum.currentLevelId,
    );

  return cityLevels.map(level => ({
    levelId: level.id,
    tower: getLevelTower(level),
    // if this is current level - put just selected topper
    // if no - put previously selected topper
    topperId: level.id === curriculum.currentLevelId || gameMode.onboardingMode ?
      feedback.selectedTopperId : gameDetails.gameDetails.toppers[level.id],
  }));
};

// returns current level bases on curriculum data
export const getCurrentLevel = curriculum => curriculum.levels[curriculum.currentLevelId];

// returns current standard item based on standardRound data
export const getCurrentStandardItem = standardRound => standardRound.standardItems[standardRound.currentStepIndex];

// returns current onboarding item based on onboardingRound data
export const getCurrentOnboardingItem = onboardingRound => getCurrentStandardItem(onboardingRound);

const getPercentage = (number, total) => Math.round(number / total * 100);

// returns progress fraction for particular step of standard round
// what does it mean: e.g. if we have 5 steps in round, progress fraction for every step will be: 0/4, 1/4, 2/4, 3/4 and 4/4
export const selectRoundProgressFraction = createSelector(
  [
    ({ standardRound }) => standardRound.currentStepIndex,
    ({ standardRound }) => standardRound.standardItems.length,
  ],
  (standardStepIndex, standardRoundLength) => (standardRoundLength ? standardStepIndex / (standardRoundLength - 1) : 0),
);

// returns progress percentage for particular step of standard round (for progress bar)
// once user answers correctly, it gets increased
export const selectRoundProgressPercentage = createSelector(
  [
    ({ standardRound }) => standardRound.currentStepIndex,
    ({ standardRound }) => standardRound.standardItems.length,
    ({ onboardingRound }) => onboardingRound.standardItems.length,
    ({ onboardingRound }) => onboardingRound.currentStepIndex,
    ({ standardStep }) => standardStep.isAnswerCorrect,
    ({ screen }) => screen.currentScreen,
  ],
  (
    standardStepIndex,
    standardRoundLength,
    onboardingRoundLength,
    onboardingStepIndex,
    isAnswerCorrect,
    currentScreen,
  ) => {
    const isStandard = currentScreen === SCREENS.STANDARD;
    const questionIndex = isStandard ? standardStepIndex : onboardingStepIndex;

    return getPercentage(
      isAnswerCorrect ? questionIndex + 1 : questionIndex,
      isStandard ? standardRoundLength : onboardingRoundLength,
    );
  },
);
